<template>

    <div class="discovery">

        <!--STEP 1-->
        <template v-if="isStep1">
            <div class="logo" v-show="isDesktop">
                <img src="/img/discovery/cleanfox-logo.svg">
            </div>
            <tuto @close="gotSTep2"></tuto>
        </template>

        <!--STEP 2-->
        <template v-if="isStep2">
            <img src="/img/discovery/official-foxy.svg" alt="foxy" class="foxy" v-show="!smilingFoxy">
            <img src="/img/discovery/official-foxy-smiling.svg" alt="smiling foxy" class="foxy-smiling" v-show="smilingFoxy">
            <div class="bubble" v-show="smilingFoxy">
                <markdown :text="$t('reproduce_actions')" class="text-xlBold"></markdown>
                <img src="/img/discovery/bubble-arrow.svg" class="bubble-arrow" alt="bubble">
            </div>
        </template>

        <!--STEP 3-->
            <newsletters-example  v-if="isStep3" @ended="goStep4" @close="close"></newsletters-example>

        <!--STEP 4-->
        <template v-if="isStep4">
            <div class="ending">
                <div class="bloc">
                    <div class="top">
                        <markdown :text="$t('done_mailbox_tidy')" class="text-xlBold" :color="'#32A3EB'"></markdown>
                        <p class="text-baseMedium mt__8">{{ $t('connect_your_mailbox_now') }}</p>
                    </div>
                    <img class="swimming-pool" src="/img/discovery/foxy-swim-2.svg">
                    <button class="cta-medium-primary" @click="goLogin">{{ $t('connect_my_mailbox') }}</button>
                </div>
            </div>
        </template>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Markdown from '../components/Markdown'
import NewslettersExample from '../components/discovery/NewslettersExample'
import Tuto from '../components/newsletters-v2/tuto/Tuto'

import Tag from '../modules/tag'


export default {

    name: 'discovery',

    components: {
        Markdown,
        NewslettersExample,
        Tuto
    },

    computed: {
        isStep1() {
            return this.step === 1
        },
        isStep2() {
            return this.step === 2
        },
        isStep3() {
            return this.step === 3
        },
        isStep4() {
            return this.step === 4
        }
    },

    data() {
        return {
            step: 0,
            smilingFoxy: false
        }
    },

    mounted() {
        this.updateDiscoveryMode(true)
        this.goStep1()
    },

    methods: {

        ...Vuex.mapActions([
            'updateDiscoveryMode'
        ]),

        goStep1() {
            this.step = 1
        },

        gotSTep2() {
            Tag.pageViewAmplitude(this, 'demo_mode_onboarding_5')
            this.step = 2

            setTimeout(() => {
                this.smilingFoxy = true
            }, 2000)

            setTimeout(() => {
                this.step = 3
                this.smilingFoxy = false
            }, 6000)
        },

        goStep4() {
            Tag.pageViewAll(this, 'demo_mode_exit_all_done')
            this.step = 4
        },

        goLogin() {
            this.$router.push({path: '/login/email'})
        },

        close() {
            this.$router.push({path: '/'})
        }
    },

    beforeDestroy() {
        this.updateDiscoveryMode(false)
    }
}
</script>

<style lang="scss" scoped>

.discovery {
    background-color: $alice-blue;
    display: flex;
    position: relative;
    align-items: center;
    @media screen and (min-width: $above-tablet-length) {
        background-repeat: no-repeat;
        background-size: cover;
        background-image: url("/img/discovery/background.svg");
    }

    .logo {
        padding-top: 32px;

        > img {
            height: 24px;
            object-fit: contain;
        }
    }

    .foxy {
        position: absolute;
        bottom: -56px;
        width: 240px;
        @media screen and (min-width: $above-tablet-length) {
            bottom: 0;
        }
    }

    .foxy-smiling {
        position: absolute;
        bottom: -56px;
        width: 240px;
        @media screen and (min-width: $above-tablet-length) {
            bottom: 0;
        }
    }

    .bubble {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 0 16px;
        width: fit-content;
        padding: 16px 12px;
        background-color: $white;
        border-radius: 24px;
        position: absolute;
        bottom: 252px;

        .bubble-arrow {
            position: absolute;
            bottom: -21px;
            right: 25%;
        }
    }

    .ending {
        padding: 16px;
        width: 100%;
        background-color: white;
        flex: 1;
        display: flex;
        justify-content: center;
        @media screen and (min-width: $above-tablet-length) {
            align-items: center;
        }

        .bloc {

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            max-width: 400px;
            @media screen and (min-width: $above-tablet-length) {
                justify-content: center;
            }
            .swimming-pool {
                width: 100%;
                object-fit: contain;

                @media screen and (min-width: $above-tablet-length) {
                    margin: 40px 0;
                }
            }

            .top {
                padding: 0 4px;
            }
        }
    }
}

</style>